<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Akten</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" style="max-height: Calc(90vh - 50px);" >
  <ng-form #myForm="ngForm">
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" required id="ResubmitCode" [(ngModel)]="Code" placeholder="Resubmit Code">
        <label for="ResubmitCode">Resubmit Code</label>
      </div>
    </div>
    <div class="col-auto">
      <button class="btn btn-primary mt-2" [disabled]="!myForm.valid" (click)="SenCode()">Speichern</button>
    </div>
  </div>
  </ng-form>
</div>
